import './styles/reagendarmuestra.css'
import { useState } from "react"

//Components
import Confirm from "../components/confirm"
import Snack from "../components/snack"

//Extras
import Imagen from '../assets/images/clasemuestra-bg.jpeg'
import Loader from "../components/loader"
import { fontType } from "../assets/extras"
import Logo from '../assets/images/logo-white.png'
import { collection, doc, getDoc, getDocs, increment, query, updateDoc, where } from 'firebase/firestore'
import { db } from '../assets/connections'
import { niveles } from '../assets/datas'
import { compareDates, getAge, getCurrentDate, getCurrentDay } from '../assets/validator'
import { DayPicker } from 'react-day-picker'
import { filterAndSortClasses, formatSubtitle } from '../assets/classUtils'
import { getUserLocation, sortSedesByDistance, formatDistance } from '../assets/geoUtils'

const ReagendarMuestra = () => {

    const [ data, setData ] = useState({
        correo_jugador: "",
        fecha_clase: "----/--/--"
    })

    //Varibles para el uso del confirm
    const [ confirm, setConfirm ] = useState({
        show: false,
        title: "",
        text: ""
    })

    const [ variables, setVariables ] = useState({
        loading: false,
        sedesData: [],
        searched: false
    })
    const [ userLocation, setUserLocation ] = useState(null)
    const [ locationStatus, setLocationStatus ] = useState("idle")
    const [ showAllSedes, setShowAllSedes ] = useState(false)
    const [ valueCalendar, setValueCalendar ] = useState(new Date())
    const [ showCalendar, setShowCalendar ] = useState(false)
    const [ selClase, setSelClase ] = useState(null)

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
                            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #56d600;'></div>"
                            : status == "warning" ?
                            "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                            : status == "error" ?
                            "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #c20000;'></div>"
                            : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Funcion que obtiene las clases muestra que esten disponibles - DINAMICA
    const getData = async (playerData) => {
        const level = playerData.nivel

        const edad = getAge(playerData.edad)

        //Ahora analizamos a que categorias pertenece el jugador y las agregamos a un arreglo
        var cathegories = []
        if(edad >= 12){
            if(edad < 18) {
                cathegories = [
                    "Juvenil 12 a 18 años",
                    "Adultos"
                ]
            } else if (edad >= 18) {
                cathegories = [
                    "Adultos"
                ]
            }
        } else if(edad < 12){
            cathegories = [
                "Infantil 4 a 8 años",
                "Infantil 8 a 12 años"
            ]
        }

        var sedesData = []

        try {
            // 1. Obtener TODAS las academias dinamicamente
            const academias = await getDocs(collection(db, "Academias"))

            for (const academia of academias.docs) {
                const academiaEmail = academia.id

                // 2. Obtener sedes activas con clases muestra habilitadas
                let sedes = []
                try {
                    const sedesSnap = await getDocs(query(
                        collection(academia.ref, "Sedes"),
                        where("activa_clases_muestra", "==", true),
                        where("activa", "==", true)
                    ))
                    sedes = sedesSnap.docs
                } catch(e) {
                    console.log("No hay sedes para " + academiaEmail + ", usando academia como sede")
                }

                if (sedes.length > 0) {
                    // Tiene sedes configuradas - cargar todas las clases y distribuir por sede
                    const allClases = await getDocs(query(
                        collection(academia.ref, "Clases"),
                        where("categoria", "in", cathegories),
                        where("nivel", "==", level),
                        where("isGroup", "==", true)
                    ))

                    const defaultSedeId = (sedes.find(s => s.data().es_default) || sedes[0]).id

                    for (const sede of sedes) {
                        const sedeData = sede.data()
                        const sedeId = sede.id

                        const sedeClases = allClases.docs.filter(d => {
                            const claseSede = d.data().sede
                            if (claseSede) return claseSede === sedeId
                            return sedeId === defaultSedeId
                        })

                        const sortedClases = filterAndSortClasses(sedeClases, academiaEmail, {
                            sedeId: sedeId,
                            nombre_sede: sedeData.nombre_sede
                        })

                        sedesData.push({
                            sedeId: sedeId,
                            nombre_sede: sedeData.nombre_sede,
                            direccion_sede: sedeData.direccion_sede,
                            coordenadas: sedeData.coordenadas || null,
                            academia: academiaEmail,
                            clases: sortedClases
                        })
                    }
                } else {
                    // Backward compatibility: academia sin sedes configuradas
                    try {
                        const clases = await getDocs(query(
                            collection(academia.ref, "Clases"),
                            where("categoria", "in", cathegories),
                            where("nivel", "==", level),
                            where("isGroup", "==", true)
                        ))

                        const sortedClases = filterAndSortClasses(clases.docs, academiaEmail)

                        if (sortedClases.length > 0) {
                            sedesData.push({
                                sedeId: "",
                                nombre_sede: academia.data().nombre_academia || academiaEmail,
                                direccion_sede: academia.data().direccion_academia || "",
                                coordenadas: null,
                                academia: academiaEmail,
                                clases: sortedClases
                            })
                        }
                    } catch(e) {
                        console.log("Error cargando clases de " + academiaEmail, e.message)
                    }
                }
            }
        } catch(e) {
            console.log(e.message)
            showMessage("Error de conexion. Intentalo de nuevo mas tarde.", "error")
        }

        setData(prev => (playerData))
        setVariables(prev => ({
            ...prev,
            loading: false,
            sedesData: sedesData,
            searched: true
        }))

        setLocationStatus("requesting")
        getUserLocation(8000)
            .then(loc => { setUserLocation(loc); setLocationStatus("granted") })
            .catch(() => setLocationStatus("denied"))

    }

    //Funcion que verifica que el usuario ya haya ingersado anteriormente
    const isRegistered = async () => {
        await getDoc(doc(db, "ClaseMuestra", data.correo_jugador)).then(async r => {
            if(r.exists()){
                const d = r.data()

                // Validamos primero si es que ya tuvo su clase muestra
                // y asistio
                if(d.isReserved === false) {
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    setTimeout(() => {
                        showMessage("No has agendado ninguna clase todavia", "warning")
                    }, 50)
                } else {
                    if(!d.asistio){
                        await getData(d)
                    } else {
                        setVariables(prev => ({
                            ...prev,
                            loading: false
                        }))
                        setTimeout(() => {
                            showMessage("Ya asististe a tu clase muestra", "warning")
                        }, 50)
                    }
                }

            } else {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("El correo ingresado no existe", "warning")
                }, 50)
            }
        }).catch(e => {
            console.log(e)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al validar existencia", "error")
            }, 50)
        })
    }

    //Funcion que actualiza la clase pasada
    const updateClass = async (ref) => {
        await updateDoc(doc(db, ref), {
            clases_muestra: increment(-1)
        }).catch(e => {
            console.log(e)
        })
    }

    //Funcion que actualiza los datos con la nueva clase
    const setNewClass = async () => {
        const newData = {
            correo: data.correo,
            academia: selClase.academia,
            asistio: false,
            checked: false,
            dias_clase: selClase.dias_clase,
            edad: data.edad,
            estatus: "----/--/--",
            fecha_clase: data.fecha_clase,
            id_clase: selClase.id,
            id_profesor: selClase.profesor_clase,
            isReserved: true,
            mensajes: 0,
            nivel: data.nivel,
            nombre: data.nombre,
            nombre_clase: selClase.nombre_clase,
            nombre_profesor: selClase.nombre_profesor,
            ref: selClase.ref,
            telefono: data.telefono,
            tipo_estatus: "",
            sede: selClase.sedeId || "",
            nombre_sede: selClase.nombre_sede || ""
        }

        await updateDoc(doc(db, "ClaseMuestra", data.correo), newData).then(async r => {
            await updateDoc(doc(db, newData.ref), {
                clases_muestra: increment(1)
            }).then(success => {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))

                setTimeout(async () => {

                    await fetch("https://us-central1-tenistapp2000.cloudfunctions.net/correo", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            correo: newData.correo,
                            nombre: newData.nombre,
                            nombre_clase: newData.nombre_clase,
                            nombre_profesor: newData.nombre_profesor,
                            fecha_clase: newData.fecha_clase,
                            dias_clase: newData.dias_clase,
                            academia: newData.academia,
                        }),
                    }).then((success) => {
                        console.log(success)
                    }).catch((error) => {
                        console.log(error)
                    })

                    showMessage("Clase muestra reservada con exito", "success")

                    setTimeout(() => {
                        window.location.reload()
                    }, 1000)
                }, 50)
            }).catch(e => {
                console.log(e)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Error al actualizar la clase", "error")
                }, 50)
            })
        }).catch(e => {
            console.log(e)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al actualizar la clase", "error")
            }, 50)
        })
    }

    //Funcion que confirma la clase
    const reserveClass = async () => {
        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        setTimeout(async () => {
            //Primero validamos si el usuario ya asistio a su clase o no
            if (data.checked === true) {
                // Ya solo actualizamos la clase
                await setNewClass()
            } else {
                // En este caso primero actualizamos la clase pasada
                await updateClass(data.ref)

                // Y luego actualizamos la clase siguiente
                await setNewClass()
            }
        }, 100)
    }

    if(variables.loading)
    return (
        <Loader
            loading={variables.loading}
        />
    )

    return (
        <div className='mainSampleClass' style={{
            backgroundImage: "url(" + Imagen + ")",
            backgroundPosition: "center",
            backgroundSize: "cover"
        }}>

            <Snack />

            <Confirm
                confirm={confirm}
                setConfirm={setConfirm}
                onHandle={async () => {
                    setConfirm(prev => ({ ...prev, show: false }))
                    await reserveClass()
                }}
            />

            <div className='contSampleClass'>

                {
                    showCalendar && (
                        <div style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 10000
                        }} onClick={() => setShowCalendar(false)}>
                            <div style={{
                                background: "#fff",
                                padding: "20px",
                                borderRadius: "10px",
                            }} onClick={(e) => e.stopPropagation()}>
                                <DayPicker
                                    style={{
                                        fontFamily: fontType.text
                                    }}
                                    mode="single"
                                    selected={valueCalendar}
                                    onSelect={(e) => {
                                        let date = new Date(e)
                                        let newDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
                                        let day = date.getDay() > 0 ? getCurrentDay(date.getDay()) : "Domingo"

                                        if(e != undefined){
                                            if(compareDates(newDate, getCurrentDate()) === 2 || compareDates(newDate, getCurrentDate()) === 0){
                                                let isClassDay = selClase.dias_clase.map((v, i) => v.dia).includes(day)

                                                if(isClassDay === true){

                                                    setData(prev => ({
                                                        ...prev,
                                                        fecha_clase: newDate
                                                    }))

                                                    setShowCalendar(false)
                                                    setConfirm(prev => ({
                                                        ...prev,
                                                        show: true,
                                                        title: "RESERVAR CLASE",
                                                        text: "¿Estas seguro de reservar tu clase muestra?"
                                                    }))

                                                } else {
                                                    showMessage("Debes de seleccionar un dia donde se imparta la clase", "warning")
                                                }
                                            }

                                        } else {
                                            setData(prev => ({
                                                ...prev,
                                                fecha_clase: newDate
                                            }))

                                            setShowCalendar(false)
                                            setConfirm(prev => ({
                                                ...prev,
                                                show: true,
                                                title: "RESERVAR CLASE",
                                                text: "¿Estas seguro de reservar tu clase muestra?"
                                            }))
                                        }
                                    }}
                                    footer={
                                        data.fecha_clase ? `Fecha: ${data.fecha_clase}` : "Pick a day."
                                    }
                                />
                            </div>
                        </div>
                    )
                }

                <div className='title'>
                    <img src={Logo} />
                </div>

                {
                    variables.searched === true ?
                        <div className='formC' style={{
                            overflowY: "scroll"
                        }}>
                            {(() => {
                                const sortedSedes = userLocation
                                    ? sortSedesByDistance(variables.sedesData, userLocation)
                                    : variables.sedesData

                                const nearestSede = sortedSedes[0]?.distance != null ? sortedSedes[0] : null
                                const otherSedes = nearestSede ? sortedSedes.slice(1) : sortedSedes
                                const hasManySeeds = variables.sedesData.length > 1

                                const renderSede = (sede, idx, isRecommended) => (
                                    <div key={sede.sedeId || idx} className={isRecommended ? 'sede-recomendada' : ''}>
                                        <p style={{
                                            fontFamily: fontType.title,
                                            color: "white",
                                            fontSize: 40,
                                            marginBottom: 5,
                                            marginTop: idx > 0 && !isRecommended ? 30 : 0,
                                            width: "100%",
                                            textAlign: "center"
                                        }}>{sede.nombre_sede.toUpperCase()}</p>
                                        {sede.distance != null && (
                                            <span className='distancia-badge' style={{
                                                fontFamily: fontType.text
                                            }}>{formatDistance(sede.distance)}</span>
                                        )}
                                        {sede.direccion_sede && (
                                            <button style={{
                                                marginBottom: 20,
                                                marginTop: 10,
                                                border: "none",
                                                padding: 12,
                                                backgroundColor: "white",
                                                borderRadius: 5,
                                                fontFamily: fontType.title,
                                                fontSize: 18,
                                                cursor: "pointer",
                                                color: "black"
                                            }} onClick={() => {
                                                if (sede.coordenadas && sede.coordenadas.lat && sede.coordenadas.lng) {
                                                    window.open(`https://www.google.com/maps?q=${sede.coordenadas.lat},${sede.coordenadas.lng}`, "_blank")
                                                } else {
                                                    window.open(`https://www.google.com/maps?q=${encodeURIComponent(sede.direccion_sede)}`, "_blank")
                                                }
                                            }}>
                                                VER UBICACION
                                            </button>
                                        )}
                                        {
                                            sede.clases.length > 0 ?
                                                sede.clases.map((v, i) => {
                                                    return (
                                                        <div className='clase' key={v.id + "-" + i} onClick={() => {
                                                            setSelClase(v)
                                                            setShowCalendar(true)
                                                        }}>
                                                            <p style={{
                                                                fontFamily: fontType.text,
                                                                fontSize: 18
                                                            }}>{formatSubtitle(v.dias_clase)}</p>
                                                            <p style={{
                                                                fontFamily: fontType.text,
                                                                fontSize: 14,
                                                                marginTop: 10
                                                            }}>{v.nombre_profesor}</p>
                                                        </div>
                                                    )
                                                })
                                            :
                                                <p style={{
                                                    color: "white",
                                                    fontSize: 20,
                                                    fontFamily: fontType.subTitle,
                                                    paddingTop: 50,
                                                    paddingBottom: 50,
                                                    width: "100%",
                                                    textAlign: "center"
                                                }}>No hay clases disponibles en este centro</p>
                                        }
                                    </div>
                                )

                                return (
                                    <>
                                        {locationStatus === "requesting" && hasManySeeds && (
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                marginBottom: 20
                                            }}>
                                                <p style={{
                                                    color: "white",
                                                    fontFamily: fontType.text,
                                                    fontSize: 16,
                                                    marginBottom: 15
                                                }}>Buscando la sede mas cercana a ti...</p>
                                                <button className='otras-sedes-btn' style={{
                                                    fontFamily: fontType.title
                                                }} onClick={() => setLocationStatus("denied")}>
                                                    SALTAR
                                                </button>
                                            </div>
                                        )}

                                        {locationStatus === "denied" && hasManySeeds && (
                                            <div className='location-banner' style={{
                                                fontFamily: fontType.text
                                            }}>
                                                Activa tu ubicacion para ver la sede mas cercana
                                            </div>
                                        )}

                                        {locationStatus === "granted" && nearestSede && hasManySeeds ? (
                                            <>
                                                <p style={{
                                                    fontFamily: fontType.title,
                                                    color: "#4CAF50",
                                                    fontSize: 18,
                                                    marginBottom: 10,
                                                    textAlign: "center"
                                                }}>SEDE RECOMENDADA</p>
                                                {renderSede(nearestSede, 0, true)}

                                                {otherSedes.length > 0 && !showAllSedes && (
                                                    <button className='otras-sedes-btn' style={{
                                                        fontFamily: fontType.title,
                                                        marginTop: 30
                                                    }} onClick={() => setShowAllSedes(true)}>
                                                        VER OTRAS SEDES ({otherSedes.length} mas)
                                                    </button>
                                                )}

                                                {showAllSedes && otherSedes.map((sede, idx) =>
                                                    renderSede(sede, idx + 1, false)
                                                )}
                                            </>
                                        ) : (
                                            locationStatus !== "requesting" || !hasManySeeds ?
                                                sortedSedes.map((sede, idx) =>
                                                    renderSede(sede, idx, false)
                                                )
                                            : null
                                        )}

                                        {variables.sedesData.length === 0 && (
                                            <p style={{
                                                color: "white",
                                                fontSize: 20,
                                                fontFamily: fontType.subTitle,
                                                paddingTop: 50,
                                                paddingBottom: 50,
                                                width: "100%",
                                                textAlign: "center"
                                            }}>No hay sedes con clases disponibles</p>
                                        )}
                                    </>
                                )
                            })()}
                        </div>
                    :
                        <div className="form">

                            <div className='contNombre' id='contNombre'>
                                <p style={{
                                    fontFamily: fontType.title
                                }}>Escribe el correo electronico registrado</p>

                                <input
                                    style={{
                                        fontFamily: fontType.text
                                    }}
                                    placeholder='example@example.com'
                                    maxLength={40}
                                    value={data.correo_jugador}
                                    onChange={e => {
                                        setData(prev => ({
                                            ...prev,
                                            correo_jugador: e.target.value.toString().replace(" ", "").toLowerCase()
                                        }))
                                    }}
                                />

                                <button onClick={async () => {
                                    setVariables(prev => ({
                                        ...prev,
                                        loading: true
                                    }))

                                    await isRegistered()
                                }} style={{
                                    fontFamily: fontType.title
                                }}>
                                    BUSCAR CLASES
                                </button>
                            </div>
                        </div>
                }
            </div>

        </div>
    )
}

export default ReagendarMuestra
